// extracted by mini-css-extract-plugin
export var cancelButton = "_n3-5";
export var content = "_n3-3";
export var createButton = "_n3-6";
export var drawerContainer = "_n3-0";
export var footer = "_n3-2";
export var header = "_n3-1";
export var orderFormColumn = "_n3-4";